module.exports = __webpack_public_path__ + "img/bluesky3100_17.03917c18.jpg";